/** @format */

import { Component, Input, OnInit } from '@angular/core';
import { Scene7Service, TaggingService, UtilityService } from '@shared/data-access/services';

@Component({
	selector: 'clp-marketing-story',
	templateUrl: './marketing-story.component.html',
	styleUrl: './marketing-story.component.scss',
	standalone: false
})
export class MarketingStoryComponent implements OnInit {
	@Input() data: any;
	@Input() spotNumber;
	@Input() imageWidthParam: string;

	imageUrl: string;
	targetService: (link: string) => '_blank' | '_self';
	createTag = TaggingService.createSimpleTag;

	constructor(
		private readonly scene7UrlService: Scene7Service,
		private readonly utilityService: UtilityService
	) {
		this.targetService = this.utilityService.target;
	}

	ngOnInit() {
		this.imageUrl = this.data ? this.scene7UrlService.scene7Url(this.data.Scene7ImagePath) : '';
	}
}
